import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { Mail, Phone, ShieldCheck, ExternalLink } from "lucide-react";
import ApiClient from "../../methods/api/apiClient";
import { getTenantInfo } from "../../utils/domain";

export default function Footer() {
  const WebDetails = useSelector((state) => state.logo);
  const reduxUser = useSelector((state) => state.user);
  const tenantInfo = getTenantInfo();
  const subDomain = "logistics.charlessmithassociates.com";
  const location = useLocation();
  const hostname = window.location.hostname;
  const isHomePage = location.pathname === "/";

  const isTenantPage =
    location.pathname.startsWith("/tenant") ||
    location.pathname === "/tenant-dashboard";
  const isTenantUser =
    reduxUser?.role === "tenant" ||
    reduxUser?.role === "Tenant-Admin" ||
    Boolean(reduxUser?.tenant_id) ||
    Boolean(reduxUser?.isTenant);

  const showTenantFooter = isTenantPage || isTenantUser;

  const [EqupmentListing, setEqupmentListing] = useState(
    localStorage.getItem("EqupmentListing")
      ? JSON.parse(localStorage.getItem("EqupmentListing"))
      : [],
  );

  const fetchEquipment = async () => {
    try {
      const params = { page: 1, count: 5, status: "active" };
      const query = new URLSearchParams(params).toString();
      const res = await ApiClient.get(`equipment-type/listing?${query}`);
      if (res?.success) {
        let data = res?.data?.data;
        if (data && data.length) {
          data = data.map((res) => ({
            name: res.title,
            id: res.id,
            image: res.image,
          }));
          data.sort((a, b) => a.name.localeCompare(b.name));
        }
        setEqupmentListing(data || []);
      }
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    fetchEquipment();
  }, []);
  return (
    <footer>
      <div
        className={`${hostname === subDomain && isHomePage ? "bg-[#0A2540]" : "bg-white"}`}
      >
        <img
          src={
            hostname === subDomain && isHomePage
              ? "/assets/img/rectangle-black.png"
              : "/assets/img/footer-rectangle2.png"
          }
          alt=""
          className="w-full h-[80px] relative top-[1px]"
        />
        <div
          className={`${hostname === subDomain && isHomePage ? "bg-[#0A2540]" : "bg-white"}`}
        >
          <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-7xl pb-12">
            <div className="space-y-6">
              <div>
                <img
                  src={WebDetails?.logo || "/assets/img/logo.png"}
                  alt={WebDetails?.portal_title || WebDetails?.company_name || "logo"}
                  className="w-[120px] max-h-[70px] object-contain mx-auto"
                />
              </div>

              {/* Support Contact Information */}
              {(WebDetails?.support_email || WebDetails?.support_phone) && (
                <div className="flex flex-wrap justify-center items-center gap-x-6 gap-y-2 text-xs text-slate-500 font-medium">
                  {WebDetails?.support_email && (
                    <span>
                      Support:{" "}
                      <a
                        href={`mailto:${WebDetails.support_email}`}
                        className="text-[#116DAE] hover:underline"
                      >
                        {WebDetails.support_email}
                      </a>
                    </span>
                  )}
                  {WebDetails?.support_phone && (
                    <span>
                      Phone:{" "}
                      <a
                        href={`tel:${WebDetails.support_phone}`}
                        className="text-[#116DAE] hover:underline"
                      >
                        {WebDetails.support_phone}
                      </a>
                    </span>
                  )}
                </div>
              )}

              <div className="max-sm:w-full text-center">
                <ul
                  className={`${
                    hostname === subDomain && isHomePage
                      ? "text-white"
                      : "text-gray-400"
                  } flex flex-wrap justify-center sm:gap-x-10 gap-5 space-y-1.5`}
                >
                  {!tenantInfo.isTenant && (
                    <li className="max-sm:w-full !m-0">
                      <Link
                        to="/"
                        className={`${
                          hostname === subDomain && isHomePage
                            ? "text-white hover:text-[#98C65A]"
                            : "text-[#414141] hover:text-[#116DAE]"
                        } text-md`}
                      >
                        Home
                      </Link>
                    </li>
                  )}
                  <li className="max-sm:w-full !m-0">
                    <Link
                      to="/products"
                      className={`${
                        hostname === subDomain && isHomePage
                          ? "text-white hover:text-[#98C65A]"
                          : "hover:text-[#116DAE] text-[#414141]"
                      } text-md`}
                    >
                      Shop Catalog
                    </Link>
                  </li>
                  {!tenantInfo.isTenant && (
                    <li className="max-sm:w-full !m-0">
                      <Link
                        to="/about/us"
                        className={`${
                          hostname === subDomain && isHomePage
                            ? "text-white hover:text-[#98C65A]"
                            : "text-[#414141] hover:text-[#116DAE]"
                        } text-md`}
                      >
                        About Us
                      </Link>
                    </li>
                  )}
                  <li className="max-sm:w-full !m-0">
                    <Link
                      to="/contact/us"
                      className={`${
                        hostname === subDomain && isHomePage
                          ? "text-white hover:text-[#98C65A]"
                          : "text-[#414141] hover:text-[#116DAE]"
                      } text-md`}
                    >
                      Contact Us
                    </Link>
                  </li>
                  <li className="max-sm:w-full !m-0">
                    <Link
                      to="/privacy-policy"
                      className={`${
                        hostname === subDomain && isHomePage
                          ? "text-white hover:text-[#98C65A]"
                          : "text-[#414141] hover:text-[#116DAE]"
                      } text-md`}
                    >
                      Privacy Policy
                    </Link>
                  </li>
                  <li className="max-sm:w-full !m-0">
                    <Link
                      to="/terms-and-conditions"
                      className={`${
                        hostname === subDomain && isHomePage
                          ? "text-white hover:text-[#98C65A]"
                          : "text-[#414141] hover:text-[#116DAE]"
                      } text-md`}
                    >
                      Terms &amp; Conditions
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div
            className={`${
              hostname === subDomain && isHomePage ? "bg-[#0A2540]" : "bg-[#1169AA]"
            } text-sm font-[300] text-white text-center p-5`}
          >
            &copy; {new Date().getFullYear()},{" "}
            <span>
              {WebDetails?.portal_title ||
                WebDetails?.company_name ||
                "Charles S. Smith & Associates"}
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
}
